class FormComponent {
  constructor() {
    this._initRangeInput();
  }

  _initRangeInput() {
    const translations = {
      fr: {
        lessThan: 'Moins de',
        max: 'Max',
        unitKm: 'km',
        unitMin: 'min',
        unitHour: 'h'
      },
      en: {
        lessThan: 'Less than',
        max: 'Max.',
        unitKm: 'km',
        unitMin: 'min',
        unitHour: 'h'
      }
    };

    const lang = document.documentElement.lang || 'fr';
    const T = translations[lang] || translations.fr;

    const formatMinutesToHours = (totalMinutes) => {
      if (totalMinutes < 60) {
        return `${totalMinutes} ${T.unitMin}`;
      }

      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      const hourString = `${hours}${T.unitHour}`;
      const minuteString = minutes > 0 ? String(minutes).padStart(2, '0') : '';

      return `${hourString}${minuteString}`;
    };

    const updateSliderDisplay = (slider) => {
      const container = slider.closest('[data-input-range]');
      if (!container) return;

      const valueSpan = container.querySelector('[data-input-range-value]');
      const type = container.dataset.type;
      const value = parseInt(slider.value, 10);

      let displayText = '';

      if (type === 'km') {
        displayText = `${T.lessThan} ${value} ${T.unitKm}`;
      } else if (type === 'min') {
        const formattedTime = formatMinutesToHours(value);
        displayText = `${T.max} ${formattedTime}`;
      }

      if (valueSpan) {
        valueSpan.textContent = displayText;
      }

      const min = parseInt(slider.min, 10);
      const max = parseInt(slider.max, 10);
      const percentage = ((value - min) / (max - min)) * 100;
      slider.style.setProperty('--progress-percentage', `${percentage}%`);
    };

    const allSliders = document.querySelectorAll('[data-input-range] input[type="range"]');

    allSliders.forEach(slider => {
      updateSliderDisplay(slider);
      slider.addEventListener('input', () => updateSliderDisplay(slider));
    });


  }

}

export const formComponent = new FormComponent();
